import React from 'react';

const AlertContainer: React.FC = ({ children }) => (
  <div className="auth-alert-container">{children}</div>
);

export default AlertContainer;
